export default {"src":"/_next/static/media/more2.007535b4.svg","height":24,"width":24,"blurWidth":0,"blurHeight":0};